// Server-side totals for the Tahsilat summary cards. Independent of the
// paginated list so the cards reflect the FULL data set, not just the
// loaded page.
export const GET_COLLECTIONS_TOTALS_QUERY = `
  query GetCollectionsTotals($where: collections_bool_exp = {}) {
    collections_aggregate(where: $where) {
      aggregate {
        count
        sum { tl_bor tl_alacak tl_bakiye }
        max { import_date }
      }
    }
  }
`;

export const GET_COLLECTIONS_QUERY = `
  query GetCollections($where: collections_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [collections_order_by!] = [{ tl_bakiye: desc }]) {
    collections_aggregate(where: $where) {
      aggregate {
        count
        sum { tl_bor tl_alacak tl_bakiye }
      }
    }
    collections(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      id
      luca_code
      tl_bor
      tl_alacak
      tl_bakiye
      import_date
      updated_at
      firm {
        id
        firm_name
        firm_short_name
        firm_city
      }
      reminders(order_by: { reminder_date: asc }) {
        id
        reminder_date
        note
      }
      payment_promises(order_by: { promise_date: asc }) {
        id
        promise_date
        amount
        note
        promised_by
      }
    }
  }
`;

export const GET_COLLECTION_BY_FIRM_QUERY = `
  query GetCollectionByFirm($firmId: Int!) {
    collections(where: { firm_id: { _eq: $firmId } }) {
      id
      luca_code
      tl_bor
      tl_alacak
      tl_bakiye
      import_date
      updated_at
      reminders(order_by: { reminder_date: asc }) {
        id
        reminder_date
        note
        created_at
        created_by_user { id first_name last_name }
      }
      payment_promises(order_by: { promise_date: desc }) {
        id
        promise_date
        amount
        note
        promised_by
        created_at
        created_by_user { id first_name last_name }
      }
    }
  }
`;

export const INSERT_COLLECTION_REMINDER_MUTATION = `
  mutation InsertCollectionReminder($object: collection_reminders_insert_input!) {
    insert_collection_reminders_one(object: $object) {
      id reminder_date note created_at
      created_by_user { id first_name last_name }
    }
  }
`;

export const DELETE_COLLECTION_REMINDER_MUTATION = `
  mutation DeleteCollectionReminder($id: Int!) {
    delete_collection_reminders_by_pk(id: $id) { id }
  }
`;

export const INSERT_PAYMENT_PROMISE_MUTATION = `
  mutation InsertPaymentPromise($object: collection_payment_promises_insert_input!) {
    insert_collection_payment_promises_one(object: $object) {
      id promise_date amount note promised_by created_at
      created_by_user { id first_name last_name }
    }
  }
`;

export const DELETE_PAYMENT_PROMISE_MUTATION = `
  mutation DeletePaymentPromise($id: Int!) {
    delete_collection_payment_promises_by_pk(id: $id) { id }
  }
`;

export const GET_EXISTING_COLLECTIONS_FIRM_IDS_QUERY = `
  query GetExistingCollectionsFirmIds($companyId: Int!) {
    collections(where: { company_id: { _eq: $companyId } }) {
      id
      firm_id
    }
  }
`;

export const GET_FIRMS_FOR_IMPORT_QUERY = `
  query GetFirmsForImport($companyId: Int!) {
    firms(
      where: { company_id: { _eq: $companyId }, luca_code: { _is_null: false } }
    ) {
      id
      firm_name
      firm_short_name
      luca_code
    }
  }
`;
